import updateAddressModalTemplate from '../views/update-address-modal.tpl.html';
import createInvoiceFromBidModalTemplate from '../views/create-invoice-from-bid-modal.tpl.html';
import createInvoiceFromCommissionModalTemplate from '../views/modals/create-invoice-from-commission-modal.tpl.html';
import infoDocumentModalTemplate from '../views/modals/info-document-modal.tpl.html';
import cancelInvoiceModalTemplate from '../views/cancel-invoice-modal.tpl.html';
import paymentEditorModalTemplate from '../views/payments/editor-modal.tpl.html';
import editModalTemplate from '../views/edit-modal.tpl.html';
import editMetaModalTemplate from '../views/edit-meta-modal.tpl.html';
import Payments from '../../../../store/billing/payments/index';
import colors from '../../../../components/deposits/colors';

class DetailsCtrl {

    constructor(locale, $state, $stateParams, Alert, Invoice, $uibModal, Error, Payments, NavService, Users, $http, Env, InvoiceActionsService, Acl, $sanitize, $translate, $scope, $injector) {
        this.locale = locale;
        this.state = $state;
        this.stateParams = $stateParams;
        this.alert = Alert;
        this.manager = $stateParams.store;
        this.invoiceModel = Invoice;
        this.uibModal = $uibModal;
        this.error = Error;
        this.paymentsBaseStore = Payments;
        this.navService = NavService;
        this.userStore = Users;
        this.api = $http;
        this.env = Env;
        this.invoiceActionsService = InvoiceActionsService;
        this.acl = Acl;
        this.sanitize = $sanitize;
        this.translate = $translate;
        this.scope = $scope;
        this.navHelper = $injector.get('NavHelper');
        this.sweetAlert = $injector.get('SweetAlert');
        this.timeout = $injector.get('$timeout');

        this.pdfData = null;
        this.invoice = {};

        if (this.manager) {
            this.refresh = this.manager.refresh;
        }
        if ($stateParams.store) {
            this.manager = $stateParams.store;
        }
        this.paymentsStore = null;
        this.paymentsEnabled = false;

        this.loadInvoice();
        this._initWatchers();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.stateParams.id;
        }, () => {
            this.loadInvoice();
        });
    }

    loadInvoice() {
        this.paymentsStore = null;
        return this.invoiceModel.one(this.stateParams.id).get({include: 'contact,positions,rsvps'}).then((record) => {
            this.invoice = record;
            this.paymentsEnabled =
                (
                    this.invoice.type === 'invoice'
                || (this.invoice.type === 'bid' && _.get(this.userStore.state.company, 'settings.billing.enable_payments_on_bids', false))
                || (this.invoice.type === 'cancellation' && _.get(this.userStore.state.company, 'settings.billing.enable_payments_on_cancellations', false))
                );

            this._updateCustomActions();
            this.loadPayments();
            this.loadPdfData();
            return this.invoice;
        }, () => {
            const translatedValue = (path) => {
                return this.translate.instant(`billing.invoices.controllers.error_not_found.${path}`);
            };

            this.alert.animatedAlert(
                translatedValue('title'),
                translatedValue('content'),
                'failed',
                {
                    confirmButtonText: translatedValue('confirm'),
                    showCancelButton: false,
                    confirmButtonColor: '#e01249'
                }
            );

            this.closeInvoice();
        });
    }

    loadPdfData() {
        this.api.get('billing/invoices/' + this.invoice.id + '/download', {responseType: "arraybuffer"})
            .then((response) => {
                this.pdfData = new Uint8Array(response.data);
            }, (response) => {
                const translatedValue = (path) => {
                    return this.translate.instant(`billing.invoices.controllers.error_pdf_download.${path}`);
                };

                this.alert.animatedAlert(
                    translatedValue('title'),
                    translatedValue('content'),
                    'failed',
                    {
                        confirmButtonText: translatedValue('confirm'),
                        showCancelButton: false,
                        confirmButtonColor: '#e01249'
                    }
                );
            });
    }

    loadPayments() {
        if(this.paymentsStore === null) {
            this.paymentsStore = this.paymentsBaseStore.reset({
                persist: false,
                listview: 'Invoice' + this.invoice.id + 'PaymentsListView',
                overrideSideNavActions: false
            });
            this.paymentsStore.commit('setPrefix', 'billing/invoices/' + this.invoice.id);
            this.paymentsStore.commit('addAction', {
                key: 'show_payment_model',
                text: 'Edit',
                level: 'row',
                action: (action) => {
                    this.editPayment(action.row.id);
                }
            });
            this.paymentsStore.commit('setVm', this);
        }
    }

    sanitize(value) {
        return this.sanitize(value);
    }

    closeInvoice() {
        this.state.go('app.billing.invoices.index');
    }

    editInvoice() {
        this.startInvoiceEditor(this.invoice).result.then((newInvoice) => {
            this.loadInvoice();
        }, () => {
            this.loadInvoice();
        });
    }

    startInvoiceEditor(invoice) {
        return this.uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: editModalTemplate,
            size: 'lg',
            controller: 'InvoicesEditModalCtrl',
            controllerAs: 'vm',
            resolve: {
                contactId: () => {
                    return invoice.contact_id;
                },
                invoice: () => {
                    return this.invoiceModel.one(invoice.id).get({include: 'positions,positions.position_link'}).then((response) => {
                        return response;
                    }, () => {
                        const translatedValue = (path) => {
                            return this.translate.instant(`billing.invoices.controllers.error_not_found.${path}`);
                        };

                        this.alert.animatedAlert(
                            translatedValue('title'),
                            translatedValue('content'),
                            'failed',
                            {
                                confirmButtonText: translatedValue('confirm'),
                                showCancelButton: false,
                                confirmButtonColor: '#e01249'
                            }
                        );
                    });
                }
            }
        });
    }

    downloadInvoice() {
        if (this.invoice.status === 'draft') {
            return this.invoiceModel.downloadInvoice(this.invoice.id, 'invoice-' + this.invoice.id + '-draft.pdf');
        } else {
            return this.invoiceModel.downloadInvoice(this.invoice.id, 'invoice-' + this.invoice.invoice_number + '.pdf');
        }
    }

    sendInvoice() {
        this.invoiceModel.sendInvoice(this.invoice, this.invoice.contact.data).then(() => {

            // @todo new alert - shows even if I don't send, only close!
            this.alert.success('Message queued', 'The email for the invoice was queued');
        });
    }

    finishInvoice() {
        return this.invoiceModel.finishInvoice(this.invoice).then((invoice) => {
            this.loadInvoice();
        });
    }

    cancelInvoice() {
        this.uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: cancelInvoiceModalTemplate,
            size: 'xlg',
            controller: 'InvoicesCancelModalCtrl',
            controllerAs: 'vm',
            resolve: {
                invoice: () => {
                    return this.invoice;
                }
            }
        }).result.then((cancellation) => {
            this.alert.success('Success', 'Cancellation was created');
            this.loadInvoice();
            this.loadPayments();
        }, (close) => {
            if (close !== true) {
                this.error.default(close);
            }
        });
    }

    editInvoiceMeta() {
        this.uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: editMetaModalTemplate,
            size: 'md',
            controller: 'InvoicesEditMetaModalCtrl',
            controllerAs: 'vm',
            resolve: {
                invoice: () => {
                    return this.invoice;
                }
            }
        }).result.then(() => {
            this.alert.success('Success', 'Metadata was saved');
            this.loadInvoice();
            this.loadPayments();
        }, (close) => {
            if (close !== true) {
                this.error.default(close);
            }
        });
    }

    deleteInvoice() {
        const translatedValue = (path) => {
            return this.translate.instant(`billing.invoices.controllers.ask_to_delete_invoice.${path}`);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content'),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel')
            }
        ).then(() => {
            return this.invoiceModel.one(this.invoice.id).remove().then((response) => {
                this.alert.success('Success', 'Invoice deleted');
            }, (e) => {
                this.error.default(e);
            });
        });
    }

    createInvoiceFromBid() {
        const modal = this.uibModal.open({
            animation: true,
            templateUrl: createInvoiceFromBidModalTemplate,
            size: 'sm',
            controller: 'CreateInvoiceFromBidController',
            controllerAs: 'vm',
            resolve: {
                bidToUse: () => {
                    return this.invoice;
                }
            }
        }).result.then((data) => {
            if (data.status === 'success') {
                this.alert.success('Created', 'Created invoice (' + data.invoice.number + ') from bid (' + this.invoice.invoice_number + ')');
                this.state.go('app.billing.invoices.details', {id: data.invoice.id, invoice: null}, {refresh: true});
            } else {
                const translatedValue = (path) => {
                    return this.translate.instant(`billing.invoices.controllers.error_create_from_bid.${path}`);
                };

                this.alert.animatedAlert(
                    translatedValue('title'),
                    translatedValue('content'),
                    'failed',
                    {
                        confirmButtonText: translatedValue('confirm'),
                        showCancelButton: false,
                        confirmButtonColor: '#e01249'
                    }
                );
            }
            this.loadInvoice();
        }, () => {
            this.loadInvoice();
        });
    }

    createInvoiceFromCommission() {
        const modal = this.uibModal.open({
            animation: true,
            templateUrl: createInvoiceFromCommissionModalTemplate,
            size: 'sm',
            controller: 'CreateInvoiceFromCommissionController',
            controllerAs: 'vm',
            resolve: {
                commissionToUse: () => {
                    return this.invoice;
                }
            }
        }).result.then((data) => {
            if (data.status === 'success') {
                this.alert.success('Created', 'Created invoice (' + data.invoice.number + ') from bid (' + this.invoice.invoice_number + ')');
                this.state.go('app.billing.invoices.details', {id: data.invoice.id, invoice: null}, {refresh: true});
            } else {
                const translatedValue = (path) => {
                    return this.translate.instant(`billing.invoices.controllers.error_create_from_bid.${path}`);
                };

                this.alert.animatedAlert(
                    translatedValue('title'),
                    translatedValue('content'),
                    'failed',
                    {
                        confirmButtonText: translatedValue('confirm'),
                        showCancelButton: false,
                        confirmButtonColor: '#e01249'
                    }
                );
            }
            this.loadInvoice();
        }, () => {
            this.loadInvoice();
        });
    }

    updateAddress() {
        this.uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: updateAddressModalTemplate,
            size: 'sm',
            controller: 'InvoicesUpdateAddressModalCtrl',
            controllerAs: 'vm',
            resolve: {
                contactId: () => {
                    return this.invoice.contact.data.id;
                },
                invoiceId: () => {
                    return this.invoice.id;
                }
            }
        }).result.then(() => {
            this.loadInvoice();
        }, () => {
            this.loadInvoice();
        });
    }

    createPayment() {
        const oldStatus = this.invoice.status;
        this.uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: paymentEditorModalTemplate,
            size: 'md',
            controller: 'InvoicesPaymentCreateModalCtrl',
            controllerAs: 'vm',
            resolve: {
                invoice: () => {
                    return this.invoice;
                }
            }
        }).result.then(() => {
            this.loadInvoice().then((invoice) => {
                if (oldStatus !== invoice.status && invoice.status === 'paid') {
                    if (_.get(this.userStore.state.company, 'settings.billing.info_document_popup_enabled', false)) {
                        this.uibModal.open({
                            animation: true,
                            ariaLabelledBy: 'modal-title-bottom',
                            ariaDescribedBy: 'modal-body-bottom',
                            templateUrl: infoDocumentModalTemplate,
                            size: 'md',
                            controller: 'BillingInfoDocumentModalController',
                            controllerAs: 'vm',
                            resolve: {
                                invoice: () => {
                                    return this.invoice;
                                }
                            }
                        })
                            .result
                            .then(
                                () => {
                                    this.askForPaymentConfirmation();
                                },
                                () => {
                                    this.askForPaymentConfirmation();
                                }
                            )
                    } else {
                        this.askForPaymentConfirmation();
                    }
                }
            });
        }, () => {
            this.loadInvoice();
        });
    }

    editPayment(paymentId) {
        const oldStatus = this.invoice.status;
        this.uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: paymentEditorModalTemplate,
            size: 'md',
            controller: 'InvoicesPaymentEditModalCtrl',
            controllerAs: 'vm',
            resolve: {
                invoice: () => {
                    return this.invoice;
                },
                payment: this.invoice.customGET('payments/' + paymentId)
            }
        }).result.then(() => {
            this.loadInvoice().then((invoice) => {
                if (oldStatus !== invoice.status && invoice.status === 'paid') {
                    if (_.get(this.userStore.state.company, 'settings.billing.info_document_popup_enabled', false)) {
                        this.sweetAlert.swal({
                            title: 'Create Info document',
                            text: 'Please don\'t forget to create the info document if needed',
                            type: "info",
                            showCancelButton: false,
                            confirmButtonColor: colors.rsvp.status.confirmed,
                            confirmButtonText: "I will do",
                            closeOnConfirm: true
                        }, (confirmed) => {
                            this.timeout(() => {
                                this.askForPaymentConfirmation();
                            }, 500);
                        });
                    } else {
                        this.askForPaymentConfirmation();
                    }
                }
            });
        }, () => {
            this.loadInvoice();
        });
    }

    askForPaymentConfirmation() {
        if (_.get(this.userStore.state.company, 'settings.billing.payment_confirmation_template', -1) > -1) {

            const translatedValue = (path) => {
                return this.translate.instant(`billing.invoices.controllers.ask_to_send_payment_confirmation.${path}`);
            };

            this.alert.animatedAlert(
                translatedValue('title'),
                translatedValue('content'),
                'attention',
                {
                    confirmButtonText: translatedValue('confirm'),
                    cancelButtonText: translatedValue('cancel')
                }).then(() => {
                this.invoiceModel.sendInvoiceWithTemplate(this.invoice, this.invoice.contact.data, _.get(this.userStore.state.company, 'settings.billing.payment_confirmation_template', -1), false).then(() => {
                    this.alert.success('Message queued', 'Payment confirmation was queued');
                }, (e) => {
                    this.error.default(e);
                });
            })
                .catch(() => {
                });
        }
    }

    createVouchersAndTickets() {
        this.invoiceActionsService.startVouchersAndTicketsModal(this.invoice).then(() => {

        }, () => {

        });
    }

    printVouchersOverviewDocument() {
        this.invoiceActionsService.printVouchersOverviewDocument(this.invoice).then(() => {
            this.alert.success('Print started', 'Started the print-job for the voucher overview.');
        });
    }

    downloadVouchersOverviewDocument() {
        this.invoiceActionsService.downloadVouchersOverviewDocument(this.invoice).then(() => {

        });
    }

    printInvoice() {
        this.invoiceActionsService.printInvoice(this.invoice).then(() => {
            this.alert.success('Print started', 'The print job for the invoice was started');
        });
    }

    _updateCustomActions() {
        this.navHelper.setTranslationsParamsForEntry('addressbook.invoices.details', {
            name: (!this.invoice.invoice_number) ? 'Draft: ' + this.invoice.contact.data.full_name : this.invoice.invoice_number
        })
        let customActions = [];

        if (this.invoice.status !== 'draft' && this.invoice.contact.data.preferred_email) {
            customActions.push({
                label: 'Send',
                action: () => {
                    this.sendInvoice();
                },
                icon: 'envelope',
                order: 5
            });
        }

        customActions.push({
            label: 'Download',
            action: () => {
                this.downloadInvoice();
            },
            icon: 'upload',
            order: 10
        });
        if (this.invoice.type === 'bid' || this.invoice.status === 'draft') {
            customActions.push({
                label: 'Edit',
                action: () => {
                    this.editInvoice();
                },
                icon: 'pencil',
                order: 15
            });
        }

        if (this.invoice.type === 'bid' || this.invoice.status === 'draft') {
            customActions.push({
                label: 'Delete',
                action: () => {
                    this.deleteInvoice();
                },
                icon: 'trash-alt',
                order: 40
            });
        }

        if (this.invoice.invoice_able) {
            customActions.push({
                label: 'Create invoice',
                action: () => {
                    if (this.invoice.type === 'bid') {
                        this.createInvoiceFromBid();
                    } else if (this.invoice.type === 'commission') {
                        this.createInvoiceFromCommission();
                    }
                },
                icon: 'file-invoice-dollar',
                order: 25
            });
        }


        if (this.invoice.status === 'draft') {
            customActions.push({
                label: 'Finish',
                action: () => {
                    this.finishInvoice();
                },
                icon: 'check',
                order: 25
            });
        }

        customActions.push({
            label: 'Edit Meta',
            action: () => {
                this.editInvoiceMeta();
            },
            icon: 'info-circle',
            order: 27
        });

        customActions.push({
            label: 'Print Invoice',
            action: () => {
                this.printInvoice();
            },
            icon: 'print',
            order: 28
        });


        if (this.paymentsEnabled) {
            customActions.push({
                label: 'Create Payment',
                action: () => {
                    this.createPayment();
                },
                icon: 'money-bill-wave',
                order: 30
            });
        }


        if (this.invoice.cancel_able) {
            customActions.push({
                label: 'Cancel Invoice',
                action: () => {
                    this.cancelInvoice();
                },
                icon: 'times-circle',
                order: 35
            });
        }


        if (this.invoice.voucher_able) {
            if (this.acl.hasRight('vouchers::create-vouchers-for-invoice')) {
                customActions.push({
                    label: 'Create Vouchers and Tickets',
                    action: () => {
                        this.createVouchersAndTickets();
                    },
                    icon: 'ticket',
                    order: 40
                });
            }
        }

        if (this.invoice.has_already_vouchers) {
            if (this.acl.hasRight('vouchers::print-overview')) {
                customActions.push({
                    label: 'Print Voucher Overview',
                    action: () => {
                        this.printVouchersOverviewDocument();
                    },
                    icon: 'print',
                    order: 45
                });
            }

            if (this.acl.hasRight('vouchers::download-overview')) {
                customActions.push({
                    label: 'Download Voucher Overview',
                    action: () => {
                        this.downloadVouchersOverviewDocument();
                    },
                    icon: 'download',
                    order: 50
                });
            }
        }

        this.navService.overrideMainSideNavActions(customActions);
        this.navService.setBreadcrumbParameters({
            invoice: (!this.invoice.invoice_number) ? 'Draft: ' + this.invoice.contact.data.full_name : this.invoice.invoice_number
        });
    }

    printInfoDocumentForRsvp(rsvp) {
        console.log('print', rsvp);
    }
}

DetailsCtrl.$inject = [
    'locale',
    '$state',
    '$stateParams',
    'Alert',
    'Invoice',
    '$uibModal',
    'Error',
    'Payments',
    'NavService',
    'Users',
    '$http',
    'Env',
    'InvoiceActionsService',
    'Acl',
    '$sanitize',
    '$translate',
    '$scope',
    '$injector'
];


/**
 * @ngdoc object
 * @name billing.invoices.controller:InvoiceDetailsCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .controller('InvoiceDetailsCtrl', DetailsCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/controllers/details-controller.js